import { render } from "./ProductionOrder.vue?vue&type=template&id=474a3516&scoped=true"
import script from "./ProductionOrder.vue?vue&type=script&lang=js"
export * from "./ProductionOrder.vue?vue&type=script&lang=js"

import "./ProductionOrder.vue?vue&type=style&index=0&id=474a3516&scoped=true&lang=css"
import "./ProductionOrder.vue?vue&type=style&index=1&id=474a3516&lang=css"

import exportComponent from "/home/dyam/Documentos/LYRASHOES/mi-stock-lyrashoes-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474a3516"]])

export default __exports__